import { AlertTriangle } from "lucide-react";

export const BlockedBanner = ({ blocked }) => {
  if (!blocked?.length) return null;
  return (
    <div
      data-testid="blocked-banner"
      className="border border-amber-700 bg-amber-500/10 px-4 py-3 flex items-start gap-3 rounded-sm"
    >
      <AlertTriangle className="h-4 w-4 text-amber-300 mt-0.5 shrink-0" />
      <ul className="text-xs text-amber-200 space-y-1 font-mono">
        {blocked.map((b) => (
          <li key={b}>{b}</li>
        ))}
      </ul>
    </div>
  );
};
